import {
  GET_NOTIFICATIONS,
  SEND_CASUAL_NOTIFICATION,
  ACCEPTED_CASUAL_NOTIFICATION,
  ACCEPTED_APPROVAL_NOTIFICATION,
  FOLLOWER_NOTIFICATION,
  APPROVAL_NOTIFICATION,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATIONS,
  NOTIFICATION_ERROR,
  CLEAR_NOTIFICATIONS,
} from "../actions/types";

const initialState = {
  notifications: [],
  notification: null,
  loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_NOTIFICATIONS:
      return {
        ...state,
        notifications: payload,
        loading: false,
      };
    case DELETE_NOTIFICATION:
      return {
        ...state,
        notifications: payload,
        loading: false,
      };
    case DELETE_NOTIFICATIONS:
      return {
        ...state,
        notifications: payload,
        loading: false,
      };
    case SEND_CASUAL_NOTIFICATION:
    case ACCEPTED_CASUAL_NOTIFICATION:
    case ACCEPTED_APPROVAL_NOTIFICATION:
    case FOLLOWER_NOTIFICATION:
    case APPROVAL_NOTIFICATION:
      return {
        ...state,
        notification: payload,
        loading: false,
      };
    case NOTIFICATION_ERROR:
      return {
        ...state,
        error: payload,
        loading: true,
      };
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notification: null,
        notifications: [],
        loading: false,
      };
    default:
      return state;
  }
}
